// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,

  // // Firebase Configuration
  firebaseConfig: {
    apiKey: "AIzaSyCHW_k9JlfRLmW5FXXMLW4qfesyxLBlhvc",
    authDomain: "aerial-handbook-429905-e5.firebaseapp.com",
    projectId: "aerial-handbook-429905-e5",
    storageBucket: "aerial-handbook-429905-e5.appspot.com",
    messagingSenderId: "397201401860",
    appId: "1:397201401860:web:27925732c2cb86bf3ced51",
    measurementId: "G-XRYSBPVH46",
  },
};
